module.exports = __webpack_public_path__ + "static/img/2.87ac8f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/sp/2.png
// module id = zGrh
// module chunks = 0